import CityPageToldos from "../components/CityPageToldos";

export default function ToldosNerja() {
  return (
    <CityPageToldos
      name="Nerja"
      slug="nerja"
      cp="29780"
      poblacion={22000}
      zonaGeo="Axarquía"
      lat={36.7474}
      lng={-3.8728}
      zonas={["Nerja Centro", "Burriana", "Capistrano", "Maro"]}
      landmarks={["Balcón de Europa", "Playa Burriana", "Cuevas de Nerja"]}
      municipiosLimitrofes={["Torrox", "Frigiliana"]}
      festivalLocal="Feria de Nerja, mediados de octubre"
      contextoTipologico="Pueblo blanco turístico, ALTÍSIMA demanda toldos comerciales en hostelería del Balcón de Europa, villas expat británicas y holandesas con grandes terrazas."
      isCoreZone={false}
    />
  );
}